import { InlineBanner } from "components/ui/inline-banner";
import React from "react";
import { Link } from "react-router-dom";

export const MailboxDisconnectedBanner: React.FC = () => {
    return (
        <InlineBanner type="error">
            <p>
                Your mailbox is disconnected, so new emails aren&#39;t being added to your
                records.{" "}
                <Link to="/settings/account/email" className="font-medium underline">
                    Reconnect your mailbox
                </Link>{" "}
                to resume syncing.
            </p>
        </InlineBanner>
    );
};
